/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Last {
  /**
   * Returns the last item of `array`.
   *
   * @public
   * @function f1.last
   * @param arr the array of values
   * @example
   *
   * ```ts
   * last([1, 2, 3]) => [3]
   * ```
   *
   */
  <T>(arr: T[]): T[];
}

/**
 * @see Last
 */
export default <T>(arr: T[]) => [arr[arr.length - 1]];
